import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'

import useAuth from '../../auth/useAuth'
import { redirectToOnboarding } from '../../auth/onboarding'

import LogoPng from '../../assets/img/logo.png'

import AuthSideComponent from '../../components/AuthSideComponent'
import LoaderComponent from '../../components/CommonComponents/LoaderComponent'
import { toast } from '../../components/CommonComponents/ToastComponent/toast'

import { signupBasic, signupNameInput } from '../../redux/actions/auth'

import { STORAGE_KEY_REGION } from '../../utils/defaultValues'

const SignupSpecialPage = () => {
  const dispatch = useDispatch()
  const history = useHistory()
  const isSigningBasic = useSelector(state => state.auth.isSigningBasic)
  const { login, isAuthenticated, isLoading, user } = useAuth()

  const [firstName, setFirstName] = useState('')
  const [lastName, setLastName] = useState('')

  useEffect(() => {
    if (!user) {
      return
    }

    dispatch(signupBasic(user.sub)).then((response) => {
      if (!response.isValid) {
        if (response.reason === 'UMS_USER_NOT_FOUND') {
          // No UMS profile yet: finish Hub onboarding, which returns here.
          if (!redirectToOnboarding()) {
            toast.show({
              title: 'Warning',
              description: 'Please finish setting up your Carbon6 profile first.',
            })
          }
        } else {
          history.push('/dashboard')
        }
      } else {
        if (typeof window.biSignup !== 'undefined') {
          window.biSignup({
            name: `${response.firstName} ${response.lastName}`,
            email: response.email,
            tool_name: 'PPC Entourage'
          })
        }

        window.sessionStorage.removeItem(STORAGE_KEY_REGION)

        if (response.firstName && response.lastName) {
          history.push('/amz-webinar-signup-complete')
        }
      }
    }).catch((error) => {
      toast.show({
        title: 'Danger',
        description: error,
      })
    })
  }, [dispatch, user]) // eslint-disable-line

  const handleConnect = () => {
    if (!firstName || !lastName) {
      toast.show({
        title: 'Danger',
        description: 'Please enter your first and last names.',
      })
      return
    }

    dispatch(signupNameInput(firstName, lastName))

    history.push('/amz-webinar-signup-complete')
  }

  if (isLoading || isSigningBasic) {
    return <LoaderComponent />
  }

  if (!isAuthenticated) {
    login({
      returnTo: '/amz-webinar-signup',
    })
    return
  }

  return (
    <div className="auth-layout">
      <div className="auth-page">
        <div className="auth-form">
          <div className="logo-header">
            <img src={LogoPng} alt="PPC Entourage" />
            PPC Entourage
          </div>
          <div className="form-title">
            Sign Up
          </div>
          <div className="form-sub-title">
            Sign up for PPC Entourage + Carbon6
          </div>
          <div className="name-input-container">
            <input
              type="text"
              placeholder="First Name"
              value={firstName}
              required
              onChange={(event) => { setFirstName(event.target.value) }}
            />
            <input
              type="text"
              placeholder="Last Name"
              value={lastName}
              required
              onChange={(event) => { setLastName(event.target.value) }}
            />
          </div>
          <button
            type="button"
            className="btn btn-navy"
            onClick={handleConnect}
          >
            Connect Amazon Accounts
          </button>
        </div>
      </div>
      <AuthSideComponent>
        Sign Up for PPC Entourage + Carbon6 account to get started.
      </AuthSideComponent>
    </div>
  )
}

export default SignupSpecialPage
